(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[319],{

/***/ 30050:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playstation",
      function () {
        return __webpack_require__(44505);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var withRouterPageLayout = function(ComposedComponent) {
    var WithRouteWrapper = /*#__PURE__*/ function(Component1) {
        "use strict";
        _inherits(WithRouteWrapper, Component1);
        var _super = _createSuper(WithRouteWrapper);
        function WithRouteWrapper() {
            _classCallCheck(this, WithRouteWrapper);
            return _super.apply(this, arguments);
        }
        _createClass(WithRouteWrapper, [
            {
                key: "render",
                value: function render() {
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ComposedComponent, _objectSpread({
                        router: this.context.router
                    }, this.props)));
                }
            }
        ]);
        return WithRouteWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_1__.Component);
    _defineProperty(WithRouteWrapper, "contextTypes", {
        router: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)
    });
    WithRouteWrapper.getInitialProps = ComposedComponent.getInitialProps;
    // Hoists non standard static properties
    WithRouteWrapper.pageLayout = ComposedComponent.pageLayout;
    WithRouteWrapper.layoutProps = ComposedComponent.layoutProps;
    WithRouteWrapper.pageName = ComposedComponent.pageName;
    return WithRouteWrapper;
};
/* harmony default export */ __webpack_exports__["Z"] = (withRouterPageLayout);


/***/ }),

/***/ 44505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_withRouterPageLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61167);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var _containers_ErrorPage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75720);






var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_3__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteName = _publicRuntimeConfig.settings.websiteName;
var PlaystationPage = function() {
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("100vh"), height = ref1[0], setHeight = ref1[1];
    var iframeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var iframeSrc = websiteName === "altex" ? "https://lcdn.altex.ro/media/ps5/" : "https://lcdn.mediagalaxy.ro/media/ps5-mg/";
    var handleIframeMessage = function(event) {
        var eventOrigin = websiteName === "altex" ? "https://lcdn.altex.ro" : "https://lcdn.mediagalaxy.ro";
        if (event.origin === eventOrigin) {
            var ref3, ref2;
            if ((ref3 = event.data) === null || ref3 === void 0 ? void 0 : ref3.height) {
                setHeight("".concat(Number(event.data.height) + 60, "px"));
            }
            if ((ref2 = event.data) === null || ref2 === void 0 ? void 0 : ref2.scrollTo) {
                var scrollPosition = iframeRef.current.offsetTop + event.data.scrollTo;
                scrollTo({
                    top: scrollPosition,
                    behavior: "smooth"
                });
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("message", handleIframeMessage);
        return function() {
            window.removeEventListener("message", handleIframeMessage);
        };
    }, []);
    if (websiteName === "bricostore") {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_ErrorPage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            layout: "404"
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_4__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Playstation"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                className: "border-0 w-full",
                src: iframeSrc,
                ref: iframeRef,
                title: "",
                style: {
                    height: height
                }
            })
        ]
    }));
};
PlaystationPage.pageLayout = "default";
/* harmony default export */ __webpack_exports__["default"] = ((0,_components_withRouterPageLayout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(PlaystationPage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(30050); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);